// // Numbers
export const onlyNumbers = /^[0-9]*$/;
export const onlyNumbersMessage = 'יש להקליד ספרות בלבד';
export const noNumbersNSymbols = /[0-9!@#$%^&*()]/;
export const isSafariBrowser = /^((?!chrome|android).)*safari/i;

// // Email
export const email = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
export const emailWithEmpty = /^$|\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
export const emailMessage =
  'יש להקליד אותיות באנגלית ואת הסימן @ בלבד, ללא רווחים';

// // letters or numbers no special chars
// export const lettersOrNumbersNoSpecialChars =
//   /^[a-zA-Z0-9א-ת-|'|" ]*$/gi;
// export const lettersOrNumbersNoSpecialCharsMessage =
//   'יש להקליד אותיות או ספרות בלבד, ללא תווים מיוחדים';

// letters or numbers with some special chars
export const illegalChars = /[^a-zA-Z0-9א-ת.'"/:,?!()|\n \r\n|-]/gi;

export const lettersOrNumbersWithSomeExtraCharsMessage =
  ' ניתן להקליד אותיות בעברית ובאנגלית, מספרים ואת התווים הבאים: , ! ? .';

// // letters or numbers with all special chars
export const notLettersOrNumbersWithExtraChars =
  /[^-a-zA-Z0-9א-ת" '|.|/|:|,|?|!|(|)|\n\r|-]+/gi;
// export const lettersOrNumbersWithExtraCharsMessage =
//   'יש להקליד אותיות או ספרות בלבד, ללא תווים מיוחדים';

// //Phone
export const numberOfDigitsInPhoneNumber = 7;

// //Misc
export const textTooLong = (textLength: number) =>
  `הטקסט שהקלדת ארוך מידי. מספר התווים המירבי הוא ${textLength}`;
export const textLengthMustBe = (textLength: number) =>
  `חייב להכיל ${textLength} ספרות`;
export const requiredMessage = 'יש למלא';
export const requiredFieldMessage = 'שדה חובה';
export const requiredPhoneMessage = 'יש למלא מספר טלפון';
export const requiredPrefixMessage = 'יש למלא קידומת';
// export const exactlyNumOfChars = (numOfChars: number) =>
//   `יש להזין ${numOfChars} תווים במדויק`;

export const notDigits = /[^0-9]/g;
export const phone = /[0-9]{7,8}/g;
// export const phoneMessage = 'ניתן להקליד מספרים בלבד';

// File name validation
export const fileName = /[^a-zA-Z0-9\u05D0-\u05EA\- _]/g;

// Israeli ID
export const isValidIsraeliID = (idString: string) => {
  if (!idString || typeof idString !== 'string') return false;

  var id = idString.trim();
  if (id.length > 9 || id.length < 4 || isNaN(parseInt(id))) return false;
  id = id.length < 9 ? ('00000000' + id)?.slice(-9) : id;
  return (
    Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }) %
      10 ===
    0
  );
};

// Returns true if a string is written in hebrew otherwise false. Regular symbols are allowed: ? ! , . %
export const isHebrew = (str: string) => {
  const hebrewRegex = /^[א-ת\s?!%,.-]+$/;
  return hebrewRegex.test(str);
};

export const noNumbersAndSymbols = (str: string) => {
  return noNumbersNSymbols.test(str);
};

export const isPhoneNumber = (str: string) => {
  const phoneRegex = /^\d{7}$/;
  return phoneRegex.test(str);
};

export const isInvoiceId = (str: string) => {
  const invoiceIdRegex = /^[a-zA-Zא-ת0-9-/]*$/;
  return invoiceIdRegex.test(str);
};

export const isValidEmail = (str: string) => {
  return emailRegexStrict.test(str);
};

export const invoiceIdInvalidMessage =
  'מספר החשבונית יכול לכלול רק מספרים, לוכסן ומקף';

export const licenseNumberInvalidMessage =
  'מספר רישיון יכול לכלול רק אותיות, מספרים, לוכסן ומקף';

export const WHITESPACE_REGEX = /\s+/g;

export const validateIsraeliIdMessage = 'מספר תעודת זהות לא תקין';

export const emailSanitation = /[^A-Za-z0-9!#$%&'*+/=?^_`{|}~@.-]/g;

export const emailRegexStrict =
  /^((?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~]|(?<=^|\.)"|"(?=$|\.|@)|(?<=".*)[ .](?=.*")|(?<!\.)\.){1,64})(@)((?:[A-Za-z0-9.-])*(?:[A-Za-z0-9])\.(?:[A-Za-z0-9]){2,})$/;

export const cannabisRequiredMessages = {
  number: 'שדה חובה, לא נוכל להתקדם בלי מספר חשבונית/קבלה',
  date: 'שדה חובה, לא נוכל להתקדם בלי התאריך',
  amount: 'שדה חובה, לא נוכל להתקדם בלי הסכום ששולם',
  maxAmountError: 'הסכום מוגבל ל 6 ספרות',
  minAmountError: 'הסכום חייב להיות גדול מ 1',
};

export const formRequiredMessages = {
  number: 'שדה חובה, לא נוכל להתקדם בלי מספר חשבונית/קבלה',
  vendorName: 'שדה חובה, לא נוכל להתקדם בלי שם נותן השירות',
  date: 'שדה חובה, לא נוכל להתקדם בלי התאריך',
  amount: 'שדה חובה, לא נוכל להתקדם בלי הסכום ששולם',
  treatmentType: 'שדה חובה, לא נוכל להתקדם בלי סוג טיפול',
  treatmentDateRequired: 'שדה חובה, לא נוכל להתקדם בלי תאריך טיפול',
  invalidDate: 'שדה חובה, לא נוכל להתקדם בלי תאריך תקין',
  healthFund: 'שדה חובה, לא נוכל להתקדם בלי קופת חולים',
  licenseNumber: 'שדה חובה, לא נוכל להתקדם בלי מספר רישיון',
  uploadInvoice: 'שדה חובה, לא נוכל להתקדם בלי העלאת חשבונית',
  caregiverCertificate: 'שדה חובה, לא נוכל להתקדם בלי העלאת אישור מטפל/מטפלת',
};

export const maxCannabisReimbursementAmount = 999999;
export const duplicateInvoiceError =
  'כבר צירפת חשבונית במספר הזה. יש לבדוק את המספר או להחליף חשבונית';

export const lettersRegex = /[a-zA-Zא-ת]/g;
export const lettersOrNumbersRegex = /[^a-zA-Z0-9א-ת0-9]/g;
